import type { OidcRpConfig } from '@idport/oidc-rp-sdk';
import { OidcRpClient } from '@idport/oidc-rp-sdk';

import type { RetailEnvironmentConfig } from '@retail/core-config';
import { getEnv } from '@luna/env';
import { logger } from '@luna/logger';
import { request } from '@luna/api';
import { createSingleton } from '@luna/utils';

const EVT_OP_STATE_CHANGED = 'session_changed';
const EVT_OP_STATE_ERROR = 'session_error';

const getRpSdkParams = (): OidcRpConfig => {
    const config = getEnv<RetailEnvironmentConfig>();
    return {
        clientId: config.clientId,
        disableIssuerValidation: config.rpDisableIssuerVerification,
        checkSession: { interval: 20, iframeId: 'op' },
        disableClearUrl: true,
        issuer: config.rpIssuerUrl,
        callback: (event) => {
            logger.debug('[RP_CALLBACK] event', event);
            if (event.type === EVT_OP_STATE_CHANGED) {
                logger.info('Session changed event', event);
                request<unknown>(`${config.prestoUrl}netbanking/my/profile`);
            }
            if (event.type === EVT_OP_STATE_ERROR) {
                logger.error('Session error event', event);
            }
        },
    };
};

const rpSdkSingleton = createSingleton<OidcRpClient | undefined>();

export const getRpSdk = (): OidcRpClient => {
    const sdk = rpSdkSingleton.get();
    if (!sdk) {
        rpSdkSingleton.set(OidcRpClient.createClient(getRpSdkParams()));
    }
    return rpSdkSingleton.get();
};
